import type { CountryRate } from '@/types/rates';

const apiHost = process.env.VUE_APP_API_HOST;

export const fetchRates = async (country: string, currency?: string, signal?: AbortSignal): Promise<CountryRate> => {
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };

  const url = `${apiHost}/v1/account/retailrates`;
  const body = JSON.stringify({
    countries: [{ country }],
    currency,
  });

  const response = await fetch(url, {
    method: 'POST',
    headers,
    body,
    signal,
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch rates: ${response.status} ${response.statusText}`);
  }

  const data = await response.json();
  return data[country] as CountryRate;
};
